import { shallowEqual, useSelector } from 'react-redux';

import type { RootState } from '@/context/store/store';

export type SiblingPosition = {
  parentId: string | null;
  siblingIndex: number;
  canMoveUp: boolean;
  canMoveDown: boolean;
};

const SENTINEL: SiblingPosition = {
  parentId: null,
  siblingIndex: -1,
  canMoveUp: false,
  canMoveDown: false,
};

export function getSiblingPosition(state: RootState, nodeId: string): SiblingPosition {
  const data = state.documentData;
  if (!(nodeId in data.parentById)) {
    return SENTINEL;
  }
  const parentId = data.parentById[nodeId];
  const siblings =
    parentId === null ? data.rootIds : (data.childrenById[parentId] ?? []);
  const siblingIndex = siblings.indexOf(nodeId);
  if (siblingIndex < 0) {
    return SENTINEL;
  }
  return {
    parentId,
    siblingIndex,
    canMoveUp: siblingIndex > 0,
    canMoveDown: siblingIndex < siblings.length - 1,
  };
}

export function useSiblingPosition(nodeId: string): SiblingPosition {
  return useSelector((state: RootState): SiblingPosition => getSiblingPosition(state, nodeId), shallowEqual);
}
